import React, { Fragment, FunctionComponent, useState } from 'react';
import { useForm } from 'react-hook-form';
import { StepperContent, StepperHeader, StepperSubmit } from '../../../../../shared/general';
import { utilsAdditionalPaymentGetDefaultValuesStep2 } from '../../utils';
import { FormElementDynamicInputTyped } from '../../../../../shared/form-elements';
import {
  CalculatorAdditionalPaymentFormFields,
  CalculatorAdditionalPaymentResultData,
  CalculatorAdditionalPaymentStep2FormFields
} from '../../types';
import { utilNumberToCurrency, utilStringToNumber } from '../../../../../../utils';
import { useFormContext } from '../../../../../../hooks';
import { useAdditionalPaymentStep2FormFields } from '../../config';
import { API_ASSETS } from '../../../../../../services';
import { useIntl } from 'react-intl';

export const CalculatorAdditionalPaymentStepperStep2: FunctionComponent<{
  id: number;
  title?: string;
}> = ({ id, title }) => {
  const intl = useIntl();
  const AdditionalPaymentStep2FormFields = useAdditionalPaymentStep2FormFields(intl);

  const [completedText, setCompletedText] = useState('');
  const { form, updateForm, updateResult, setError, isLoading, setLoading } = useFormContext<
    CalculatorAdditionalPaymentResultData,
    CalculatorAdditionalPaymentFormFields
  >();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isValid }
  } = useForm({
    mode: 'onBlur',
    defaultValues: utilsAdditionalPaymentGetDefaultValuesStep2(intl)
  });

  const showAdditionFormFields = ['annafl', 'linafl'].includes(form.mortgageType);

  const onSubmit = async (
    formData: Record<keyof CalculatorAdditionalPaymentStep2FormFields, string>
  ) => {
    setLoading(true);
    try {
      // @TODO implement api call POST and set result, with form data
      const result = await API_ASSETS.get<CalculatorAdditionalPaymentResultData>(
        `calculators/additional-payment/json/result-mock.json`
      );
      updateResult(result);
      updateForm(formData);
      const { additionalPayment } = formData;
      setCompletedText(utilNumberToCurrency(utilStringToNumber(additionalPayment), true, 0));
      setLoading(false);
    } catch (e) {
      setError(true);
      setLoading(false);
      // Handle error
    }
  };

  if (isLoading) {
    return <div>Loading...</div>; // Or a more sophisticated loading indicator
  }

  return (
    <Fragment>
      <StepperHeader
        onClose={handleSubmit(onSubmit)}
        title={title}
        id={id}
        completedText={completedText}
      />
      <StepperContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormElementDynamicInputTyped<CalculatorAdditionalPaymentStep2FormFields>
            formFields={AdditionalPaymentStep2FormFields}
            id={'additionalPayment'}
            register={register}
            errors={errors}
            values={watch()}
            options={{ required: true }}
          />

          {showAdditionFormFields && (
            <FormElementDynamicInputTyped<CalculatorAdditionalPaymentStep2FormFields>
              formFields={AdditionalPaymentStep2FormFields}
              id={'paymentType'}
              register={register}
              errors={errors}
              values={watch()}
              options={{ required: true }}
            />
          )}

          <StepperSubmit
            id={id}
            isValidated={isValid}
            label={intl.formatMessage({
              id: `step2.button.calculate`,
              defaultMessage: `Bereken`
            })}
          />
        </form>
      </StepperContent>
    </Fragment>
  );
};
